<template>
  <div class="curativeBody">
    <div class="curativeContainer">
      <div class="curativeItem" v-for="(item, index) in curativeConfig" :key="index + item.label">
        <!-- {{ item.status }}--{{ activeIndex }} -->
        <auth-img class="iconImg" :src="calcSatusImg(item)" alt="" />
        <div class="label">{{ item.label }}</div>
      </div>
    </div>
    <a-divider v-if="isEvlatued" />
    <div class="curativeRes" v-if="isEvlatued">
      <div
        :style="{
          marginBottom: EvalutedStatus === 100 ? '10px' : 0
        }"
      >
        {{ renderMsg() }}
      </div>
    </div>
    <div class="curativeRes" v-if="isEvlatued && EvalutedStatus === 100">
      <div>患者反馈用药结束时间</div>
      <div>{{ medicationEndDate }}</div>
      <div>{{ groupType }}</div>
    </div>
    <div
      class="feedback"
      v-if="EvalutedStatus !== 0 && activeIndex === 0 && props.isGroup !== 0 && isEvlatued"
    >
      <div class="btn askHelper"><img :src="askHelper" alt="" /></div>
      <div class="btn"><img :src="askDoctor" alt="" /></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed, ref } from 'vue'
import askDoctor from '@/assets/img/chat/ask-doctor.png'
import askHelper from '@/assets/img/chat/ask-helper.png'
import { CurativeEvalatueTypes } from './config'
const props = defineProps({
  trackConfig: {
    type: Object,
    default: () => {}
  },
  eventCode: {
    type: String,
    default: () => {}
  },
  isGroup: {
    type: Boolean,
    default: false
  }
})
const curativeConfig = ref(CurativeEvalatueTypes)

const { customEvent, flowResultStatus, medicationEndDate } = props.trackConfig || {}

// 已评价结果
const EvalutedStatus = computed(() => Number(flowResultStatus))
// 29501 疗效跟踪待评价 29502 疗效跟踪已评价
const isEvlatued = computed(() =>
  customEvent ? customEvent !== '29501' : props.eventCode !== '29501'
)
// // 评价对应 Config Index
const activeIndex = curativeConfig.value.findIndex(
  item => item.status === Number(EvalutedStatus.value)
)

const calcSatusImg = ctx => {
  if (!isEvlatued.value) {
    return ctx.activeIcon
  } else {
    // console.log('activeIndex.value', activeIndex.value, ctx)
    return ctx.status === EvalutedStatus.value ? ctx.activeIcon : ctx.icon
  }
}
//展示文案
const renderMsg = () => {
  const msg = curativeConfig?.value.find(c => c.status == EvalutedStatus.value)
  console.log('qw', msg)
  return msg?.activeMsg
}
</script>

<style lang="scss" scoped>
.curativeBody {
  width: 100%;

  .curativeContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .curativeItem {
      width: 54px;
      height: 68px;
      background: #f9f9f9;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 9px 6px;

      .iconImg {
        width: 28px;
        height: 28px;
      }

      .label {
        font-weight: 400;
        font-size: 14px;
        color: #1a1a1a;
        margin-top: 4px;
      }
    }
  }

  .curativeRes {
    font-weight: 400;
    font-size: 14px;
    color: #3b3b3b;
  }

  ::v-deep(.ant-divider-horizontal) {
    margin: 12px 0;
  }

  .feedback {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    img {
      width: 100%;
    }
    .askHelper {
      margin-right: 9px;
    }
  }
}
</style>
